import {
  BaseEntityFieldInfos,
  BaseEntityInfoUtils,
  EntityFieldInfo
} from '@record-it-npm/synchro-common';
import { EntityName } from '../../EntityName';
import { UserGroupSubEntityDto } from './UserGroupSubEntityDto';
import { AppCommonSynchronizationEnvironmentTypes } from '../../AppCommonSynchronizationEnvironment';

export class UserGroupSubEntityInfoUtils {
  private constructor() {}

  public static createBaseFieldInfos(): UserGroupSubEntityFieldInfos {
    return {
      ...BaseEntityInfoUtils.createBaseFieldInfos(),
      ownerUserGroupId: {
        name: 'ownerUserGroupId',
        ref: EntityName.UserGroup
      }
    };
  }
}

export type UserGroupSubEntityFieldInfos =
  BaseEntityFieldInfos<AppCommonSynchronizationEnvironmentTypes> & {
    ownerUserGroupId: EntityFieldInfo<
      AppCommonSynchronizationEnvironmentTypes,
      UserGroupSubEntityDto,
      'ownerUserGroupId'
    >;
  };
